import pxToRem from './px-to-rem';
import remToPx from './rem-to-px';

export const blockOverflow = (className = 'default', enabled = true, restoreScroll = true) => {
	if(enabled) {
		if(window.scrollY && restoreScroll && !window.restoreScrollKey) {
			window.restoreScroll = pxToRem(window.scrollY);
			window.restoreScrollKey = className;
			document.body.style.marginTop = `-${window.restoreScroll}rem`;
			document.body.style.paddingBottom = `${window.restoreScroll}rem`;
			document.body.style.boxSizing = 'content-box';
		}
		document.documentElement.classList.add('block-overflow-' + className);
	}
	else {
		document.documentElement.classList.remove('block-overflow-' + className);

		if(window.restoreScroll && window.restoreScrollKey === className) {
			document.body.style.marginTop = null;
			document.body.style.paddingBottom = null;
			document.body.style.boxSizing = null;
			window.scroll(0, remToPx(window.restoreScroll));
			window.restoreScrollKey = null;
			window.restoreScroll = null;
		}
	}
}

export default blockOverflow